/**
 * Enumeration for the result of a report.
 *
 * Encodes the 'severity' in the value (higher is worse).
 */
export const Result = {
  NO_RESULT: 0,
  SUCCESSFUL: 1,
  SUCCESSFUL_WITH_WARNING: 2,
  FAILED: 3,
} as const;

/**
 * The numeric severity value of a report result.
 */
export type ResultValue = (typeof Result)[keyof typeof Result];

export default Result;
